<div class="container-fluid col-12 col-md-10 col-xl-6">

    <div class="justify-content-center">
        <div class="row justify-content-center">
            <mat-slide-toggle class="col-auto" [(ngModel)]="Model.ContexteHorsStrategie" [disabled]="!IsCreation"> Hors Stratégie ?</mat-slide-toggle>
        </div>

        <div class="card mt-3">

            <h5 class="card-header">
                <span class="row">
                    <span class="col-auto">Documents</span>
                    <mat-icon class="material-symbols-outlined col-auto p-0"
                        matTooltip="Plan de retrait, bilan aéraulique, fiche processus, mode opératoire, avenant ...">help</mat-icon>
                </span>
            </h5>
            <div class="card-body">

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                        <div class="m-1 border rounded">
                            <div class="justify-content-center text-center">
                                <div class="row justify-content-center">
                                    <button appPreventDoubleClick class="icon-button-large" mat-icon-button color="warn"
                                        (throttledClick)="openElementNecessaire()">
                                        <mat-icon class="material-symbols-outlined">description</mat-icon>
                                    </button>
                                </div>
                                <div class="row mb-1">
                                    <div>Eléments nécessaires à <br>l'élaboration d'une stratégie</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if (!Model.ContexteHorsStrategie && !hasPDREDocument()) {

                    <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                        <div class="m-1 border rounded">
                            <div class="justify-content-center text-center">
                                <div class="row justify-content-center">
                                    <button class="icon-button-large" mat-icon-button color="primary" appPreventDoubleClick
                                        (throttledClick)="openDocumentDialog(EDocumentType.PDRE)">
                                        <mat-icon class="material-symbols-outlined">description</mat-icon>
                                    </button>
                                </div>
                                <div class="row mb-1">
                                    <div>Avez-vous un PDRE Demat&#64;miante à ajouter ?</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    @for (d of Model.Portfolio.PortfolioDocuments; track d) {
                    <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                        <div class="m-1 border rounded">
                            <div class="justify-content-center text-center">
                                <div class="row justify-content-around">
                                    <div style="height: 10px; width: 40px;"></div>
                                    <button class="icon-button-large" mat-icon-button color="primary">
                                        <mat-icon class="material-symbols-outlined">description</mat-icon>
                                    </button>
                                    <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteDocument(d)">
                                        <mat-icon class="material-symbols-outlined">clear</mat-icon>
                                    </button>
                                </div>
                                <div class="row mb-1">
                                    <div>{{d.FileName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                        <div class="m-1 border rounded">
                            <div class="justify-content-center text-center">
                                <div class="row">
                                    <button class="col icon-button-large" appPreventDoubleClick mat-icon-button color="accent"
                                        (throttledClick)="openDocumentDialog(EDocumentType.PortFolio)" onclick="this.blur()">
                                        <mat-icon class="material-symbols-outlined">note_add</mat-icon>
                                    </button>
                                </div>
                                <div class="row mb-1">
                                    <div>Nouveau</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card  mt-3">

            <h5 class="card-header ">Localisation</h5>
            <div class="card-body">
                <div class="row ">
                    <mat-form-field class="col">
                        <input matInput placeholder="Nom du chantier" [(ngModel)]="Model.Portfolio.SamplingPoint.Name" [disabled]="!IsEditable()"
                            [formControl]="ValidMaxLength" required>
                        <mat-hint align="end">{{Model.Portfolio.SamplingPoint.Name?.length || 0}}/{{MAX_LENGTH}}</mat-hint>
                        @if (ValidMaxLength.hasError('maxlength')) {
                        <mat-error>
                            Nom de chantier trop long
                        </mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="row">

                    <mat-form-field class="col">
                        <input matInput placeholder="Entrer une adresse" [(ngModel)]="SearchedText" [matAutocomplete]="auto" type="text" aria-label="adresse"
                            [formControl]="ValidFullAddress" (keyup)="onKeyUp()" [disabled]="!IsEditable()" required>
                        @if (!ValidFullAddress.valid) {
                        <mat-error>
                            Merci de valider une adresse en la selectionnant dans la liste déroulante
                        </mat-error>
                        }
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="assignSelectedAddress($event)" [displayWith]="displayFn"
                            [compareWith]="compareLocalisationWith">
                            @for (address of MatchingAddressList; track address) {
                            <mat-option [value]="address.Label">
                                @if (address.Type !== 'municipality') {
                                <span>{{address.Label}}</span>
                                }
                                @if (address.Type === 'municipality') {
                                <span>{{address.Label}} ({{address.PostCode}})</span>
                                }
                            </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="Entrer un complément d'adresse" [(ngModel)]="Model.Portfolio.SamplingPoint.AdditionalAddress" type="text"
                            aria-label="complément d'adresse" [disabled]="!IsEditable()" [formControl]="ValidAddtionalAddressMaxLength">
                        <mat-hint align="end">{{Model.Portfolio.SamplingPoint.AdditionalAddress?.length || 0}}/{{MAX_LENGTH}}</mat-hint>
                        @if (ValidAddtionalAddressMaxLength.hasError('maxlength')) {
                        <mat-error>
                            Complément d'adresse trop long
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="col">
                        <mat-select placeholder="Sélectionner un laboratoire Eurofins" [(ngModel)]="Model.Portfolio.PartnerCode" [disabled]="!IsEditable()">
                            @for (p of PartnerList; track p) {
                            <mat-option [value]="p.PartnerCode">
                                {{p.PartnerName}}
                            </mat-option>
                            }
                        </mat-select>
                        <!-- <mat-error i18n="@@selectRequiredError" *ngIf="workForm.get('subsection_type').hasError('required')">
            Please select a value
          </mat-error> -->
                    </mat-form-field>
                </div>
                @if (IsExternal) {

                <div class="row">
                    <mat-form-field class="col">
                        <mat-select placeholder="Selectionner votre entreprise" [(ngModel)]="Model.Portfolio.Client" [compareWith]="compareWith"
                            (selectionChange)="updateClient()" required>
                            @for (client of ClientList; track client) {
                            <mat-option [value]="client">
                                {{client.Code}} - {{ client.Name}} {{client.City}}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                } @else {
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="Choisissez un client" [(ngModel)]="ClientSearchedText" [matAutocomplete]="auto1" type="text"
                            aria-label="client" (keyup)="onKeyUpForClient()">
                        <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="assignSelectedClient($event)" [displayWith]="displayFn" [compareWith]="compareWith" required>
                            @for (client of ClientList; track client) {
                            <mat-option [value]="client">
                                {{client.Code}} - {{ client.Name}} {{ client.City }}
                            </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                }
            </div>
        </div>

        @if (!Model.ContexteHorsStrategie) {
        <div class="card  mt-3">
            <h5 class="card-header ">Objectifs de la stratégie</h5>
            <div class="card-body">
                <!-- <div class="row justify-content-center align-items-center">
        <div class="col-auto pe-3">
          Méthode de la stratégie
        </div>
        <mat-button-toggle-group [(ngModel)]="Model.IsFDX" class="col-4 p-0">
          <mat-button-toggle class="col" [class.selected]="!Model.IsFDX" [value]="false" (click)="reassignForm()">
            <div>GA X</div>
          </mat-button-toggle>
          <mat-button-toggle class="col" [class.selected]="Model.IsFDX" [value]="true" (click)="reassignForm()">
            <div >
              <div>FD X
                <span style="position: absolute; z-index: 1000; top: 6px; right: -40px" class="badge bg-primary" >New</span>
              </div>
            </div>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div> -->
                <!-- <div class="row">
      <mat-form-field class="col">
        <mat-select placeholder="Sous-section" [(ngModel)]="Model.Work.SubSection" [disabled]="!IsEditable()">
          <mat-option *ngFor="let subsectionType of SubSectionTypeList; let i = index" [value]="i + 1">
            {{subsectionType}}
          </mat-option>
        </mat-select>
        <mat-error i18n="@@selectRequiredError" *ngIf="workForm.get('subsection_type').hasError('required')">
          Please select a value
        </mat-error>
      </mat-form-field>
    </div> -->
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="Date de début" [matDatepicker]="picker" [(ngModel)]="Model.Work.StartDate" (focus)="picker.open()"
                            [disabled]="!IsEditable()" [required]="IsDateAndDurationMandatory">
                        <!-- <mat-error i18n="@@inputRequiredError" *ngIf="workForm.get('start_date').hasError('required')">
        Please enter a value
      </mat-error> -->
                    </mat-form-field>
                    <mat-datepicker #picker></mat-datepicker>
                </div>
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="Durée de l'opération" type="number" step="1" [(ngModel)]="Model.Work.WorkDuration"
                            [disabled]="!IsEditable()" [formControl]="ValidWorkDurationNumber" [required]="IsDateAndDurationMandatory">
                        @if (!ValidWorkDurationNumber.valid) {
                        <mat-error>
                            La durée doit être comprise entre 0 et 100
                        </mat-error>
                        }
                        <!-- <mat-error i18n="@@inputRequiredError" *ngIf="workForm.get('work_duration').hasError('required')">
      Please enter a value
    </mat-error>
    <mat-error *ngIf="workForm.get('work_duration').hasError('pattern')">
      Entrez un nombre à une décimale
    </mat-error>
    <mat-error i18n="@@inputNonZeroDayRequiredError" *ngIf="workForm.get('work_duration').hasError('min')">
      Value should be at least 1 day
    </mat-error> -->
                    </mat-form-field>
                    <mat-form-field class="col">
                        <mat-select placeholder="" [(ngModel)]="Model.Work.WorkPeriodicity" [disabled]="!IsEditable()" required>
                            <!-- @for (f of FrequencyList; track f; let j = $index) {
                            <mat-option [value]="j + 2">
                                {{f}}
                            </mat-option>
                            } -->
                            <mat-option [value]="2">Jour(s)</mat-option>
                            <mat-option [value]="3">Semaine(s)</mat-option>
                            <mat-option [value]="4">Mois</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                @if (!Model.IsFDX) {
                <div class="mt-3">
                    <div class="row mt-3">
                        <div class="col-xl-4 col-md-6 col-12">
                            <mat-checkbox [(ngModel)]="Model.HasInitialMeasurement" [disabled]="!IsEditable()"> Mesures état initiale</mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 col-md-6 col-12">
                            <mat-checkbox [(ngModel)]="Model.HasEnvironmentalMeasurement" [disabled]="!IsEditable()"> Mesures environnementales en cours de
                                chantier </mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 col-md-6 col-12">
                            <mat-checkbox [(ngModel)]="Model.HasPostMaintenanceMeasurement" [disabled]="!IsEditable()"> Mesures de restitution </mat-checkbox>
                        </div>
                    </div>
                </div>
                }
                @if (Model.IsFDX) {
                <div class="mt-3">
                    <div class="row">
                        <div class="col-4">
                            <h6>
                                Hors contexte travaux
                            </h6>
                        </div>
                        <div class="col-4">
                            <h6>
                                Travaux ou intervention
                            </h6>
                        </div>
                        <div class="col-4">
                            <h6>
                                Mesure Opérateur
                            </h6>
                        </div>
                        <div class="col-4">
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasNormalRoomUsage"> Surveillance périodique </mat-checkbox>
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasFollowingIncident"> Suite à incident </mat-checkbox>
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasEndOfAsbestosProcessingWork"> Secondes restitutions </mat-checkbox>
                        </div>
                        <div class="col-4">
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasBeforeWork"> Avant travaux </mat-checkbox>
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasDuringWorkEnvironmental"> Environnementales chantier </mat-checkbox>
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasEndOfAsbestosWork"> Premières restitutions </mat-checkbox>
                            <mat-checkbox class="w-100" [(ngModel)]="Model.Work.HasEndOfAsbestosWork2"> Fins de chantier </mat-checkbox>
                        </div>
                        <div class="col-4">
                            <mat-checkbox [(ngModel)]="Model.Work.HasDuringWorkOperator"> Mesure opérateur </mat-checkbox>
                        </div>
                    </div>
                </div>
                }
                <div class="card mt-3 m-1">
                    <h5 class="card-header">
                        <span class="row">
                            <span class="col-auto">Mesures opérateur à ajouter à la stratégie</span>
                            <mat-icon class="material-symbols-outlined" class="col-auto p-0"
                                matTooltip="Processus, validation/évaluation, Temps représentatif (Tr) ...">engineering</mat-icon>
                        </span>
                    </h5>
                    <div class="card-body">
                        <div class="row">
                            @for (p of Model.ProcessList; track p) {
                            <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                                <div class="m-1 border rounded">
                                    <div class="justify-content-center text-center">
                                        <div class="row justify-content-around align-items-center">
                                            <div class="col p-3 h-100">
                                                <div class="w-100 mb-1 h-100">
                                                    <div>{{p}}</div>
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteProcess(p)">
                                                    <mat-icon class="material-symbols-outlined">clear</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                                <div class="m-1 border rounded">
                                    <div class="justify-content-center text-center">
                                        <div class="row">
                                            <button class="col icon-button-large" appPreventDoubleClick mat-icon-button color="accent"
                                                (throttledClick)="openEditTextBox()" onclick="this.blur()">
                                                <mat-icon class="material-symbols-outlined">note_add</mat-icon>
                                            </button>
                                        </div>
                                        <div class="row mb-1">
                                            <div>Nouveau</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <mat-form-field class="col">
                        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"
                            placeholder="informations complémentaires (périmètre d'investigation, accès ...)" [(ngModel)]="Model.Comment"
                            [disabled]="!IsEditable()"></textarea>
                        <!-- <mat-hint align="end">{{Model.Portfolio.SamplingPoint.Name?.length || 0}}/{{MAX_LENGTH}}</mat-hint>
    <mat-error *ngIf="ValidMaxLength.hasError('maxlength')">
      Nom de chantier trop long
    </mat-error> -->
                    </mat-form-field>
                </div>
            </div>
        </div>
        }

        <div class="card mt-3">

            <h5 class="card-header">Contacts sur site</h5>
            <div class="card-body">
                <div class="row">
                    @for (contact of Model.Portfolio.AlternateContactList; track contact) {
                    <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                        <div class="m-1 border rounded h-100">
                            <div class="justify-content-center text-center">
                                <div class="row justify-content-around">
                                    <div class="p-0" style="height: 10px; width: 40px;"></div>
                                    <div class="p-0 col-auto d-flex align-items-center fw-bold"> {{contact.LastName}}<br />{{contact.FirstName}}</div>
                                    <button class="p-0" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteContact(contact)">
                                        <mat-icon class="material-symbols-outlined">clear</mat-icon>
                                    </button>
                                </div>
                                <div class="row mb-1">
                                    <div>{{contact.Phone}}</div>
                                    <div>{{contact.Email}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="col-12 col-sm-6 col-md-4 col-xl-4 ">
                        <div class="m-1 border rounded h-100">
                            <div class="justify-content-center text-center">
                                <div class="row">
                                    <button class="col icon-button-large" appPreventDoubleClick mat-icon-button color="accent"
                                        (throttledClick)="openContactDialog()" onclick="this.blur()">
                                        <mat-icon class="material-symbols-outlined">face</mat-icon>
                                    </button>
                                </div>
                                <div class="row mb-1">
                                    <div>Nouveau</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        @if (Model.IsFDX && !Model.ContexteHorsStrategie) {
        <div class="row my-3">
            <div class="col">
                <mat-checkbox [(ngModel)]="Model.WithPerimeter"> Je fournis dans les documents ci-dessus le périmètre d'investigation </mat-checkbox>
                <div class="fst-italic">à défaut le périmètre chantier sera considéré</div>
            </div>
        </div>
        }

        <div class="row my-3">
            <span class="fst-italic text-end"><small>(*) Champs obligatoires</small></span>
        </div>
        <div class="row my-3">
            <button class="col mx-3" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="navigateToStrategyList()">
                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                <span class="ms-2">Annuler</span>
            </button>
            @if (!IsCreation) {
            <button class="col mx-3" appPreventDoubleClick mat-raised-button color="warn" (throttledClick)="deleteStrategy()" [disabled]="!IsEditable()">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                <span class="ms-2">Supprimer</span>
            </button>
            }
            <button class="col mx-3" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="save()" [disabled]="!canSave()">
                <mat-icon class="material-symbols-outlined">send</mat-icon>
                @if (!Model.ContexteHorsStrategie) {
                <span class="ms-2">Envoyer</span>
                }
                @if (Model.ContexteHorsStrategie) {
                <span class="ms-2">Commander des mesures</span>
                }
            </button>
        </div>
    </div>
</div>